export const INLINE_VARIANT = 'inline';
export const CURSOR_VARIANT = 'cursor';

export const TOP_POSITION = 'top';
export const BOTTOM_POSITION = 'bottom';
export const START_POSITION = 'start';
export const END_POSITION = 'end';
